export enum DragIconPositionVariants {
  Right = 'right',
  Left = 'left',
  None = 'none',
}
